import { useEffect, useState } from 'react'
import { useAppSelector } from "../../../../../../redux/hooks"
import { getInstancesWithAdd, getInstancesWithAddglobal } from '../request/request';
import axios from 'axios';
import { utils, writeFile } from 'xlsx';
import { useCallback } from 'react';
import { useAuth } from '../../../../auth';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL

type BGP = {
  network: string,
  nexthop: string,
  weight: string,
  locprf: string,
  rt: string
}
type vrf = {
  vendor: string,
  vrf: string
  subscription: (string)
}



export default function BGP(props: any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)




  const [Instancia, setInstancia] = useState([{
    id: 0,
    name: " ",
    type: ''
  }])

  const [Busqueda, setBusqueda] = useState("")

  const [listvrf, setlistvrff] = useState<vrf[]>([])

  const [family, setfamily] = useState("")
  const { currentUser } = useAuth()


  /**********************Llamada a axios y parse de data**********************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP')) {

          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.BGP', Type, nameregion);
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.BGP', Type, nameregion);
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
        }
        else if (Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP')) {

          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.BGP');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.BGP');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
        }

      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };
    fetchData();
  }, [nameregion]
  )


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP')) {
          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.BGP');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.BGP');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }

          }

        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id]
  )


  /////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Busqueda !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }
          if (type === "ctx") {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: Id
            }
            await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }
          else if (type === "add") {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: Id
            }
            await axios.post(API_URL + '/v1/listVrf/add?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }
        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Busqueda, Id])
  /////////////////////////////////////////////////////



  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && Type === 'CloudGlobal' && Busqueda !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }

          if (type === 'ctx') {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: '-1'
            }
            await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }
          if (type === 'add') {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: '-1'
            }
            await axios.post(API_URL + '/v1/listVrf/add?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }




        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Busqueda, Id, Type])


  ////////////////////////////////////////////////////////////
  const [vrfselect, setselectvrf] = useState<any>()

  const cambiarstate = (e: any) => {
    setBusqueda(e.target.value)
  }


  const vrfseleccionada = (e: any) => {
    setselectvrf(e.target.value)
  }



  /*****************************Nuevo**************************************** */
  const [DataBGP, setDataBGP] = useState<BGP[]>([])


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (props.tab === 3) {

      try {
        if (Busqueda === '') {
          Swal.fire(
            'Oooops!',
            'Please select an Instance',
            'warning',
          )
        }
        else if (vrfselect === '') {
          Swal.fire(
            'Oooops!',
            'Please select a VRF',
            'warning',

          )
        }
        else if (family === '') {
          Swal.fire(
            'Oooops!',
            'Please select BGP Family',
            'warning',

          )
        }

        else if (Busqueda !== '' && vrfselect !== '' && family !== '') {

          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }

          const vrf = listvrf[vrfselect]
          const body = {
            l3vrf: vrf,
            type: type,
            family: family
          }


          if (tenant === 0) {
            await axios.post(API_URL + '/v1/troubleshooting/instances/BGPl3vrf/' + Busqueda, body)
              .then(res => {
                setDataBGP(res.data)
              })
          }
          else {
            await axios.post(API_URL + '/v1/troubleshooting/instances/BGPl3vrf/' + Busqueda + '?tenantId=' + tenant, body)
              .then(res => {
                setDataBGP(res.data)
              })
          }

        }
      }
      catch (error: any) {
        console.log(error)

      }

    }
  }

  useEffect(() => {
    if (Type) {

      setDataBGP([])
    }
    if (tenant) {
      setDataBGP([])
    }
  }, [Type, tenant])

  useEffect(() => {
    if (Busqueda) {
      setselectvrf("")
      setfamily("")

    }
  }, [Busqueda])

  /********************************************* */

  const exportFile = useCallback(() => {
    // Obtén la fecha actual
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Añade ceros a la izquierda si es necesario
    const day = currentDate.getDate().toString().padStart(2, '0');

    // Formatea la fecha en el formato deseado (por ejemplo, YYYY-MM-DD)
    const formattedDate = `${year}-${month}-${day}`;
    const dataToExport = [...DataBGP];

    const sortedData = dataToExport.map(item => ({
      '': item.rt,
      'Weight': item.network,
      'LocPrf': item.nexthop,
      'Next Hop': item.locprf,
      'Network': item.weight,
    }));
    /* generate worksheet from state */
    const ws = utils.json_to_sheet(sortedData);
    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "BGP Table");
    utils.sheet_add_aoa(ws, [["", "Network", "Next Hop", "LocPrf", "Weight"]], { origin: "A1" });
    /* export to XLSX */
    let nombre
    for (const x of Instancia) {
      if (Number(Busqueda) === x.id) {
        nombre = x.name
      }
    }
    writeFile(wb, nombre + "_BGP_Table_" + formattedDate + ".xlsx");

  }, [DataBGP]);




  return (
    <>
      <div style={{ marginTop: '15px' }} className="f-titulo fs-md mb-3 text-marino text-center ">
        BGP Table
      </div>
      <div
        className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid '
        id='kt_create_account_stepper'
      >
        {/* begin::Aside*/}
        <div className='card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9 border border-gray-300' style={{ marginBottom: '20px' }}>
          {/* begin::Wrapper*/}
          <div className='card-body px-6 px-lg-10 px-xxl-15 py-20'>
            {/* begin::Nav*/}
            <div className='stepper-nav'>
              {/* begin::Step 1*/}
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 flex-center">
                      <div className="d-flex flex-column flex-row-auto">
                        <label className='form-label f-bold fs-p text-marino  required form-label' >Instance</label>
                        <select className="custom-select w-200px" aria-label="Select example"
                          onChange={cambiarstate} value={Busqueda}>
                          {Instancia.length === 0 && <option hidden>No data</option>}
                          <option hidden>Select an Instance </option>
                          {Id !== 0 && Instancia.map((ins: any, i) =>
                            <option key={i} value={ins.id}>{ins.name}</option>
                          )
                          }
                          {Id === -1 && Type === 'CloudGlobal' && Instancia.map((ins: any, i) =>
                            <option key={i} value={ins.id}>{ins.name}</option>
                          )
                          }

                        </select>
                      </div>
                      <div className='w-30px'></div>
                      <div className="d-flex flex-column flex-row-auto">
                        <label className='form-label  f-bold fs-p text-marino  required form-label' >VRF</label>
                        <select className="custom-select w-200px" aria-label="Select example"
                          onChange={vrfseleccionada} value={vrfselect}>
                          {listvrf?.length === 0 ? <option key={'x'} className='text-danger bg-info' hidden>No VRF</option> : <option hidden>Select an VRF </option>}

                          {Busqueda !== '' && Id !== 0 && Id !== -1 && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                            <>
                              {!vrf.vrf && <option key={i} value={i}>Main</option>}
                              {vrf.vrf && <option key={i} value={i}>{vrf.vrf}</option>}
                            </>
                          )
                          }

                          {Busqueda !== '' && Id === -1 && Type === 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                            <>
                              {!vrf.vrf && <option key={i} value={i}>Main({vrf.subscriptions})</option>}
                              {vrf.vrf && <option key={i} value={i}>{vrf.vrf}({vrf.subscriptions})</option>}
                            </>
                          )
                          }
                        </select>
                      </div>
                      <div className='w-30px'></div>

                      {currentUser?.is_demo !== true && <div className="d-flex flex-column flex-row-auto">
                        <label className='form-label  f-bold fs-p text-marino  required form-label' >BGP Family</label>
                        <select className="custom-select w-200px" aria-label="Select example"
                          onChange={(e) => setfamily(e.target.value)} value={family}>
                          <option hidden>Select VRF Family</option>
                          <option key={1} value='flowspec'>Flowspec</option>
                          <option key={2} value='labeled-unicast'>Labeled-Unicast</option>
                          <option key={3} value="multicast">Multicast</option>
                          <option key={4} value="unicast">Unicast</option>
                          <option key={5} value="vpn">VPN</option>
                        </select>
                      </div>}

                      {currentUser?.is_demo === true && <div className="d-flex flex-column flex-row-auto">
                        <label className='form-label  f-bold fs-p text-marino  required form-label' >BGP Family</label>
                        <select className="custom-select w-200px" aria-label="Select example"
                          onChange={(e) => setfamily(e.target.value)} value={family}>
                          <option hidden>Select VRF Family</option>
                          <option key={4} value="unicast">Unicast</option>
                        </select>
                      </div>}
                      <div className='w-30px'></div>
                      <br />
                      <br />

                      <div className="d-flex flex-column flex-row-auto  ">
                        <br />
                        <button
                          type='submit'
                          onClick={handleSubmit}
                          className='btn-light-marino'
                        >
                          <span className='indicator-label'>Search</span>
                        </button>
                      </div>

                      <div className='w-30px'></div>
                      <div className='text-center'>
                        <br />
                        <button className="btn-light-marino" onClick={exportFile}> <i className="bi bi-download" style={{ color: 'white' }}></i>Export Excel </button>

                      </div>
                    </div>

                    {/*<div  className="d-flex flex-column flex-row-auto  ">
                        <br />
                        <button className="btn-light-marino" onClick={exportFile}> <i className="bi bi-download" style={{color:'white'}}></i>Export Excel </button>

                                </div>*/}

                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

              </div>
              {/* end::Step 1*/}

            </div>
            {/* end::Nav*/}
          </div>
          {/* end::Wrapper*/}
        </div>
        {/* begin::Aside*/}

        <div className='black-background d-flex flex-row-fluid  bg-body rounded border ' style={{ marginBottom: '20px' }}>
          <div className='w-100'>
            <div className='pb-10 pb-lg-15'>
              <div className="card-body card-scroll  h-450px">
                <table className="w-full f-parrafo  caption-bottom  custom-table"  >
                  <thead className="table-header-light bg-marino">
                    <tr>
                      <th className='table-cell'>Network</th>
                      <th className='table-cell'>Next Hop</th>
                      <th className='table-cell'>LocPrf</th>
                      <th className='table-cell'>Weight</th>
                    </tr>
                  </thead>
                  <tbody style={{ marginTop: '0px' }}>
                    {DataBGP !== null &&
                      DataBGP?.map((d, i) => (
                        <>
                          {d.rt !== '' &&

                            <div className='f-parrafo'>{d.rt}</div>
                          }
                          <tr key={i} className='table-row'>
                            <td className='table-cell'>{d.network}</td>
                            {d.nexthop.includes(" ") ?
                              <td className='table-cell'>
                                {d.nexthop.split(" ")[0]}
                                <br />
                                {d.nexthop.split(" ")[1]}
                              </td>
                              : <td className='table-cell'>{d.nexthop}</td>
                            }
                            {d.locprf.includes(" ") ?
                              <td className='table-cell'>
                                {d.locprf.split(" ")[0]}
                                <br />
                                {d.locprf.split(" ")[1]}
                              </td>
                              : <td className='table-cell'>{d.locprf}</td>
                            }
                            <td className='table-cell'>{d.weight}</td>

                          </tr>


                        </>
                      ))}

                  </tbody>

                </table>
              </div>
              {Id === -1 && Type !== 'CloudGlobal' &&
                <table className="table table-striped gy-7 gs-7">
                  <tbody>
                    <div className="text-center">
                      Select a Cloud with available subscriptions
                    </div>
                  </tbody>
                </table>}

            </div>

          </div>

        </div>
      </div>
    </>
  )

}
